import { useEffect } from "react";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";

const UploaderLogicWrapper = ({ children }) => {
  const { setOpenUploader, setSpamProtection } = useUploader();
  const { closeModal, getModalOverlayClass } = useModal();

  useEffect(() => {
    setOpenUploader(true);

    // changeChunkSizeModal - when we have this modal open, we don't want to close it
    // it`s warning user about chunk size change and reload of uploader
    if (getModalOverlayClass() !== "changeChunkSizeModal") {
      closeModal();
    }
  }, []);

  const handleCheckSpamSettings = async () => {
    const res = await apiRequest("Mails", "GetVerificationCodeSettings");
    if (res.status === "success") {
      setSpamProtection({
        link: res.data.isVerificationCodeActiveGenerateLink,
        mail: res.data.isVerificationCodeActiveSendMail,
        captcha: res.data?.hasOwnProperty("isWithCaptcha")
          ? res.data.isWithCaptcha
          : true,
      });
    }
  };

  useEffect(() => {
    handleCheckSpamSettings();
  }, []);

  return children;
};

export default UploaderLogicWrapper;
